import React, { ReactNode, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Flex } from '@balance-web/flex';
import { LoadingDots } from '@balance-web/loading';

import { getUserPoolClientData } from '../utils/helper';
import { configureAmplifyAuth } from '../utils/auth';
import { mfaTokenPrefix } from '../constants';

export const IdContext = React.createContext<any>({});

export const IdContextProvider = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const [clientData, setClientData] = useState({
    clientId: '',
    redirectURL: '',
    tenancy: '',
    product: '',
    clientState: '',
    useCookieStorage: '',
  });

  const [sessionMfaKey, setSessionMfaKey] = useState('');

  useEffect(() => {
    const checkValidReq = (tenancy: string, pathname: string) => {
      if (
        process.env.STAGE !== 'dev' &&
        ((router.asPath.includes('client_id') && router?.query?.client_id) ||
          !router.asPath.includes('client_id')) &&
        ![
          '/',
          '/login',
          '/forgot-password',
          '/reset-password',
          '/signout',
          '/signup',
          '/mfa',
          '/verifycode',
          '/mfa-recovery',
        ].includes(pathname)
      ) {
        throw new Error('Bad request');
      }
    };

    if (!clientData?.clientId) {
      const [
        wClientId,
        wRedirect,
        wTenancy,
        wProduct,
        wUseCookieStorage,
        wState,
      ] = getUserPoolClientData(router);

      checkValidReq(wTenancy || '', router.pathname);
      setSessionMfaKey(`${mfaTokenPrefix}.${wClientId || ''}.token`);

      if (wClientId) {
        setClientData({
          clientId: wClientId || '',
          redirectURL: wRedirect || '',
          tenancy: wTenancy || '',
          product: wProduct || '',
          clientState: wState || '',
          useCookieStorage: wUseCookieStorage || '',
        });
        if (wClientId !== clientData?.clientId) configureAmplifyAuth(wClientId);
      }
    } else {
      checkValidReq(clientData?.tenancy || '', router.pathname);
    }
  }, [router, clientData, sessionMfaKey]);

  if (!clientData?.clientId) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <LoadingDots label="Intial data loading" size="large" />
      </Flex>
    );
  }

  return (
    <IdContext.Provider value={{ ...clientData, sessionMfaKey }}>
      {children}
    </IdContext.Provider>
  );
};
